import React from 'react';

const BecomePartnerCard: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full bg-gray-800/50 p-8 rounded-xl border border-gray-700 text-center">
      <h2 className="text-2xl font-bold text-white mb-4">Become a Partner to Create Events</h2>
      <p className="text-gray-300 mb-6 max-w-md">
        To create events in DreamWorld, you need to become a partner. Partners get access to exclusive features, including event creation.
      </p>
      <div className="space-y-4 text-left">
        <div className="flex items-start space-x-3">
          <div className="bg-green-500 rounded-full w-6 h-6 flex items-center justify-center mt-1">
            <span className="text-white font-bold">1</span>
          </div>
          <div>
            <h3 className="font-semibold text-white">Reach 1,000 Followers</h3>
            <p className="text-gray-400 text-sm">Grow your community and build your audience on DreamWorld.</p>
          </div>
        </div>
        <div className="flex items-start space-x-3">
          <div className="bg-green-500 rounded-full w-6 h-6 flex items-center justify-center mt-1">
            <span className="text-white font-bold">2</span>
          </div>
          <div>
            <h3 className="font-semibold text-white">Apply for Partnership</h3>
            <p className="text-gray-400 text-sm">Once you have 1,000 followers, you can apply to become a partner.</p>
          </div>
        </div>
      </div>
      <button
        disabled
        className="mt-8 px-8 py-3 bg-indigo-600 text-white font-semibold rounded-lg shadow-lg cursor-not-allowed opacity-50"
      >
        Apply for Partnership (Coming Soon)
      </button>
    </div>
  );
};

export default BecomePartnerCard;
